export const galleyImageOptions = {
  angle: 'galley',
  staticOptions: {
    Floorboard: 1,
    Handrail: 1,
    Fabric: 1,
    Worktop: 1,
    SaloonTableBox: 1,
    SaloonPouffe: 1,
    SaloonBackRest: 1,
    CupboardsSaloon: 1,
    FabricOwnersCabin: 1,
    CupboardsOwnersCabin: 1,
    beautytable: 1,
    LargeWardrobe: 1,
    FabricAftCabin: 1,
    AftCabinLayout: 1,
    Mast: 1,
    LeatherHandles: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: 'GalleyLayout'
    },
    {
      option: 'Fabric',
      dependency: 'GalleyLayout'
    },
    {
      option: 'Worktop',
      dependency: 'GalleyLayout'
    },
    {
      option: 'SaloonBackRest',
      dependency: 'Fabric'
    },
    {
      option: 'CupboardsSaloon',
      dependency: 'Veneer'
    },
    {
      option: 'LeatherHandles',
      dependency: 'Veneer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X56/views/galley.js